// extracted by mini-css-extract-plugin
export default {"contentContainer":"RubricFrame_contentContainer__he-Ei","questionsList":"RubricFrame_questionsList__tUMZE"};